/* eslint-disable react/require-default-props */
import React from 'react';
import { Controller, Control } from 'react-hook-form';

import { VbzInputText } from '@smiles/voebiz-ui-kit';

type PropsT = {
  control: Control;
  name: string;
  error: any;
  textLabel: string;
  rules?: Record<string, unknown>;
  placeholder: string;
  errorMessage?: string;
  onKeyDown?: any;
  regex?: any;
  maxLength?: number;
  minLength?: number;
  icon?: any;
  normalizeFunction?: (value: string) => string;
  register?: any;
  inputMode?: 'search' | 'text' | 'email' | 'tel' | 'url' | 'none' | 'numeric' | 'decimal';
};

export default function ControlledInput(props: PropsT) {
  return (
    <Controller
      name={props.name}
      control={props.control}
      rules={props.rules}
      render={({ name, onChange, value }) => (
        <VbzInputText
          maxLength={props.maxLength}
          minLength={props.minLength}
          name={name}
          regex={props.regex}
          placeholder={props.placeholder}
          textLabel={props.textLabel}
          onChange={onChange}
          ref={props.register}
          forceError={Boolean(props.error)}
          errorMessage={props.errorMessage}
          onKeyDown={props.onKeyDown}
          inputMode={props.inputMode}
          icon={props.icon}
          value={props.normalizeFunction && value && props.normalizeFunction(value)}
        />
      )}
    />
  );
}
